var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterviewLevel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513339"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2902",
    x: 0.25,
    y: 0.25,
    width: 25.5,
    height: 25.5,
    rx: 3.75,
    fill: "white",
    stroke: "#D7D7D7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 513381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 12V17.3333C7 18.0697 7.59695 18.6667 8.33333 18.6667H12.3333M7 12V9.33333C7 8.59695 7.59695 8 8.33333 8H17.6667C18.4031 8 19 8.59695 19 9.33333V12M7 12H19M19 12V14",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.334 14.668V16.668M16.334 16.668V18.668M16.334 16.668H14.334M16.334 16.668H18.334",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16732 9.9987C9.16732 10.0907 9.0927 10.1654 9.00065 10.1654C8.9086 10.1654 8.83398 10.0907 8.83398 9.9987C8.83398 9.90665 8.9086 9.83203 9.00065 9.83203C9.0927 9.83203 9.16732 9.90665 9.16732 9.9987Z",
    fill: "black",
    stroke: "#5B6B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.1673 9.9987C11.1673 10.0907 11.0927 10.1654 11.0007 10.1654C10.9086 10.1654 10.834 10.0907 10.834 9.9987C10.834 9.90665 10.9086 9.83203 11.0007 9.83203C11.0927 9.83203 11.1673 9.90665 11.1673 9.9987Z",
    fill: "black",
    stroke: "#5B6B79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewLevel);
export default __webpack_public_path__ + "static/media/interview_level.d9b92e1a4bb900ea92141a6ea5aff5e0.svg";
export { ForwardRef as ReactComponent };